import { connect } from 'react-redux'
import CurrentPerformance from '../../components/performance/CurrentPerformance'
import * as groupActions from '../../actions/group'
import * as disciplineActions from '../../actions/discipline'
import * as performanceActions from '../../actions/performance'
import * as currentPerformanceActions from '../../actions/currentPerformance'
import * as studentResultFilesActions from '../../actions/studentResultFiles'
import { getStudentResultFile } from '../../actions/studentResultFiles';


const mapStateToProps = ({ currentPerformance, discipline, group, performance, auth: { isTeacher, mid } }) => ({
  isLoading: currentPerformance.isLoading,
  years: group.years,
  disciplines: discipline.disciplines,
  disciplinesByTerm: discipline.disciplinesByTerm,
  terms: performance.terms,
  currentPerformances: currentPerformance.currentPerformances,
  modalData: currentPerformance.modalWindow.data,
  resultIndStudent: currentPerformance.resultIndStudent,
  resultGroupStudents: currentPerformance.resultGroupStudents,
  userId: mid
})

const mapDispatchToProps = dispatch => ({
  fetchCurrentPerformances: (cId, termId) => dispatch(currentPerformanceActions.currentPerformances(cId, termId)),
  fetchDisciplines: termId => dispatch(disciplineActions.disciplinesByTerm(termId)),
  fetchYears: () => dispatch(groupActions.schoolYear()),
  fetchTerms: yearId => dispatch(performanceActions.terms(yearId)),
  fetchFiles: (sheId, instance, type, typeOfWork) => dispatch(currentPerformanceActions.files(sheId, instance, type, typeOfWork)),
  fetchStudentFiles: (sheId, instance, type,) => dispatch(currentPerformanceActions.studentResultFiles(sheId, instance, type,)),
  fetchGroupStudentsFiles: (sheId, instance, type,) => dispatch(currentPerformanceActions.fetchGroupStudentsFiles(sheId, instance, type,)),
  // fetchStudentFiles: (...args) => dispatch(getStudentResultFile(...args)),

  uploadFile: (file, sheId, instance, type, typeOfWork, userId) =>
    dispatch(currentPerformanceActions.uploadFile(file, sheId, instance, type, typeOfWork, userId)),
  deleteFile: (filename, sheId, instance, type, typeOfWork) =>
    dispatch(currentPerformanceActions.deleteFile(filename, sheId, instance, type, typeOfWork)),
  download: (filename, sheId, instance, type, typeOfWork) =>
    dispatch(currentPerformanceActions.downloadFile(filename, sheId, instance, type, typeOfWork)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CurrentPerformance)
